import type { EditorVariable } from "../components/RichTextEditor/VariableNode";

const VARIABLE_LABELS: Record<string, string> = {
  identBailleur: "Identité du bailleur",
  identLocataire: "Identité du locataire",
  adresseBailleur: "Adresse du bailleur",
  adresseLocataire: "Adresse du locataire",
  nomLocataire: "Nom du locataire",
  nomNaissanceLocataire: "Nom et date de naissance du locataire",
  villeBailleur: "Ville du bailleur",
  VilleBien: "Ville du bien",
  adresseBien: "Adresse du bien",
  nomBien: "Nom du bien",
  Today: "Date du jour",
  dateDuBail: "Date de signature du bail",
  dateBail: "Date de signature du bail",
  DebutBail: "Début du bail",
  montantLoyer: "Loyer actuel",
  nouveauLoyer: "Nouveau loyer",
  montantCharge: "Charges actuelles",
  MontantCharge: "Charges actuelles",
  nouveauCharges: "Nouvelles charges",
  dateEffet: "Date d'effet",
  TelBailleur: "Téléphone du bailleur",
  EmailBailleur: "Email du bailleur",
  iban: "IBAN du bailleur",
  trimestre: "Trimestre IRL",
  indice: "Indice IRL",
  motif: "Motif",
  modif: "Modification",
  TypeCharge: "Type de charge",
  dureeSupp: "Durée supplémentaire",
  dureeBail: "Durée du bail",
};

const VARIABLE_REGEX = /\{(\w+)\}/g;

export function extractVariableKeys(templateContent: string): string[] {
  const keys = new Set<string>();
  for (const match of templateContent.matchAll(VARIABLE_REGEX)) {
    keys.add(match[1]);
  }
  return Array.from(keys);
}

export function getCourrierVariables(
  templateContent: string,
): EditorVariable[] {
  return extractVariableKeys(templateContent).map((key) => ({
    key,
    label: VARIABLE_LABELS[key] ?? key,
  }));
}

export function wrapVariablesAsPills(templateContent: string): string {
  return templateContent.replace(
    VARIABLE_REGEX,
    (_, key) => `<span data-variable="${key}">{${key}}</span>`,
  );
}
